// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************/
.switch-cassia {
    --circle-dim: 1em;
    font-size: 15px;
    position: relative;
    display: inline-block;
    width: 3.5em;
    height: 1.5em;
  }
  
  /* Hide default HTML checkbox */
  .switch-cassia input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  /* The slider */
  .slider-switch-cassia {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f5aeae;
    transition: .4s;
    border-radius: 30px;
  }
  
  .slider-card-switch-cassia {
    position: absolute;
    content: "";
    height: var(--circle-dim);
    width: var(--circle-dim);
    border-radius: 20px;
    left: 0.3em;
    bottom: 0.3em;
    transition: .4s;
    pointer-events: none;
  }
  
  .slider-card-face-switch-cassia {
    position: absolute;
    inset: 0;
    backface-visibility: hidden;
    perspective: 1000px;
    border-radius: 50%;
    transition: .4s transform;
  }
  
  .slider-card-front-switch-cassia {
    background-color: #DC3535;
  }
  
  .slider-card-back-switch-cassia {
    background-color: #379237;
    transform: rotateY(180deg);
  }
  
  input:checked ~ .slider-card-switch-cassia .slider-card-back-switch-cassia {
    transform: rotateY(0);
  }
  
  input:checked ~ .slider-card-switch-cassia .slider-card-front-switch-cassia {
    transform: rotateY(-180deg);
  }
  
  input:checked ~ .slider-card-switch-cassia {
    transform: translateX(1.5em);
  }
  
  input:checked ~ .slider-switch-cassia {
    background-color: #9ed99c;
  }`, "",{"version":3,"sources":["webpack://./src/components/generales/styles/SwitchCassia.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,aAAa;EACf;;EAEA,+BAA+B;EAC/B;IACE,UAAU;IACV,QAAQ;IACR,SAAS;EACX;;EAEA,eAAe;EACf;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["/********************************************/\r\n.switch-cassia {\r\n    --circle-dim: 1em;\r\n    font-size: 15px;\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 3.5em;\r\n    height: 1.5em;\r\n  }\r\n  \r\n  /* Hide default HTML checkbox */\r\n  .switch-cassia input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n  \r\n  /* The slider */\r\n  .slider-switch-cassia {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #f5aeae;\r\n    transition: .4s;\r\n    border-radius: 30px;\r\n  }\r\n  \r\n  .slider-card-switch-cassia {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: var(--circle-dim);\r\n    width: var(--circle-dim);\r\n    border-radius: 20px;\r\n    left: 0.3em;\r\n    bottom: 0.3em;\r\n    transition: .4s;\r\n    pointer-events: none;\r\n  }\r\n  \r\n  .slider-card-face-switch-cassia {\r\n    position: absolute;\r\n    inset: 0;\r\n    backface-visibility: hidden;\r\n    perspective: 1000px;\r\n    border-radius: 50%;\r\n    transition: .4s transform;\r\n  }\r\n  \r\n  .slider-card-front-switch-cassia {\r\n    background-color: #DC3535;\r\n  }\r\n  \r\n  .slider-card-back-switch-cassia {\r\n    background-color: #379237;\r\n    transform: rotateY(180deg);\r\n  }\r\n  \r\n  input:checked ~ .slider-card-switch-cassia .slider-card-back-switch-cassia {\r\n    transform: rotateY(0);\r\n  }\r\n  \r\n  input:checked ~ .slider-card-switch-cassia .slider-card-front-switch-cassia {\r\n    transform: rotateY(-180deg);\r\n  }\r\n  \r\n  input:checked ~ .slider-card-switch-cassia {\r\n    transform: translateX(1.5em);\r\n  }\r\n  \r\n  input:checked ~ .slider-switch-cassia {\r\n    background-color: #9ed99c;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
